/**
 * Frame-accurate playback in the browser, shared by the Analyser and the Composer. A stored edge is
 * floor(pts) of a frame; the browser shows the frame whose interval contains the time, so a seek aims
 * one millisecond inside an in edge, and a per-frame watch stops just before an out edge, where a
 * settling seek puts the picture on the last kept frame.
 */
export const EDGE_INSET_MS = 1;
/** How early (ms) the per-frame watcher may stop playback before the out point; the settling seek does the rest. */
export const FRAME_WATCH_LEAD_MS = 15;
export const insideEdge = (ms: number): number => ms + EDGE_INSET_MS;

/**
 * Where a presented frame stands against an exclusive out edge, from the frame callback's media time:
 * `play` while more frames are kept after it, `last` when it is the final kept frame (the next one,
 * `frameMs` later, starts at or past the edge), `past` when it starts past the edge itself and must not
 * stay on screen. Without a frame duration yet (the first callback), only `past` can be told apart.
 */
export function frameAgainstEdge(presentedMs: number, frameMs: number | null, untilMs: number): 'play' | 'last' | 'past' {
  if (presentedMs >= untilMs - EDGE_INSET_MS) return 'past';
  if (frameMs !== null && presentedMs + frameMs >= untilMs - EDGE_INSET_MS) return 'last';
  return 'play';
}
